/**
 * GA4 `email_signup` conversion event — July 2026 Groups Experiment.
 *
 * GA4 (G-SLMQ992BDV) is installed via Shopify's sandboxed web pixel, so a custom
 * event has to be sent from a main-document gtag instance (configured in theme.liquid).
 * Shopify's `{% form 'customer' %}` newsletter forms are native POSTs that reload the
 * page with `?customer_posted=true`; on that page ALL customer forms report success,
 * so we can't tell which one was used from Liquid alone. Instead we record the form the
 * visitor actually submitted (survives the reload via sessionStorage), then fire once on
 * the success page with the right `signup_form` label.
 *
 * GA4 session attribution (Session source/medium/campaign) attaches automatically, so a
 * visitor who landed on a UTM-tagged link gets the signup credited to that campaign.
 */
(function () {
  var GA4_ID = 'G-SLMQ992BDV';
  var STORE_KEY = 'tqrSignupForm';

  // Element id -> signup_form label. Footer form is global (every page);
  // the Reflections-hub calm form only exists on the Reflections page.
  var FORMS = {
    ContactFooter: 'footer_global',
    ReflectionsSignupForm: 'reflections_hub'
  };

  // 1) Remember which form the visitor submitted (do not block the native POST).
  Object.keys(FORMS).forEach(function (id) {
    var form = document.getElementById(id);
    if (!form) return;
    form.addEventListener('submit', function () {
      try {
        sessionStorage.setItem(STORE_KEY, FORMS[id]);
      } catch (e) {
        /* sessionStorage unavailable (private mode) — event just won't fire */
      }
    });
  });

  // 2) On the post-submit reload, if Shopify reports success, fire the event once.
  try {
    var which = sessionStorage.getItem(STORE_KEY);
    if (!which) return;

    var posted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
    var succeeded = posted || !!document.querySelector('.newsletter-form__message--success');
    if (!succeeded) return;

    sessionStorage.removeItem(STORE_KEY); // clear first so a reload can't double-fire
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'email_signup', {
        signup_form: which,
        send_to: GA4_ID
      });
    }
  } catch (e) {
    /* never let analytics break the page */
  }
})();
